const BASE_URL = 'https://goit-hw-wallet-group5-back.onrender.com';
// 'http://localhost:5000'
// 'https://goit-hw-wallet-group5-back.onrender.com';

export default BASE_URL;
